<template>
    <div class="rp-external-hd-ack">
        <i class="el-icon-loading" v-if="status === 'Loading'" />
        <i class="el-icon-circle-check" v-if="status === 'Success'" />
        <i class="el-icon-circle-close" v-if="status === 'Error'" />
         <el-button
            @click="retry"
            type="text"
            v-if="status === 'Error'"
            class="rp-external-hd-ack__cta rp-font-sizer"
        >
        {{ $t('homeScreen.retry') }}
        </el-button>

        <div class="rp-external-hd-ack__message rp-font-sizer">
            {{ status === 'Success' ? $t('homeScreen.successMessage', { email: customerEmail }) : '' }}
            {{ status === 'Error' ? $t('homeScreen.errorOccured') : '' }}
            {{ status === 'Loading' ? $t('homeScreen.loadingMessage') : '' }}
        </div>

        <el-button
            v-if="status !== 'Loading'"
            @click="goHome"
            plain
            class="uppercase-text rp-external-hd-ack__cta rp-font-sizer"
        >
            {{$t('homeScreen.goHome')}}
        </el-button>
    </div>    
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props: {
        status: {
            type: String,
            default: "Loading"
        },
    },

    methods: {
        goHome() {
            this.$emit('go-home', {})
        }
    },

    computed: {
        ...mapGetters({
            "customerEmail":"customerEmail"
        })
    }
}
</script>
<style lang="scss" scoped>
.rp-external-hd-ack {
    padding: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    text-align: center  ;
    .el-icon-circle-check, .el-icon-circle-close, .el-icon-loading {
        font-size: 100px;
    }
    .el-icon-circle-check {
        color: green;
    }
    .el-icon-circle-close {
        color: #f12525e0;
    }
    .rp-external-hd-ack__cta {
        color: var(--theme-color);
        border-color: var(--theme-color);
    }
    .rp-external-hd-ack__message {
        margin: 50px 0px;
    }
    .rp-font-sizer{
        @include for-size(desktop-up){
            font-size: 22px;
        }
        font-size: 16px;
    }
}
</style>